export { default as TabHeaderDetail } from './Detail.tab';
export { default as TabHeaderSelf } from './Self.tab';
export { default as TabHeaderRoutine } from './Routine.tab';
